




import Vue from 'vue'
import { mapState } from 'vuex'
import Component from 'vue-class-component'
import JavascriptAPI from '@/utils/JavascriptAPI'

@Component({
  props: {
    type: { type: String, required: false, default: 'form-loader' } // can also be provider-loader
  }
})
export default class InitLoader extends Vue {
  get loaderClasses () {
    return `${this.$props.type} skeleton-loader`
  }
}
